module.exports = __webpack_public_path__ + "img/logo_blanco_pequenno.a7fbdf5f.png";